import { render } from "./PostsPage.vue?vue&type=template&id=0cb66f7e&scoped=true"
import script from "./PostsPage.vue?vue&type=script&lang=js"
export * from "./PostsPage.vue?vue&type=script&lang=js"

import "./PostsPage.vue?vue&type=style&index=0&id=0cb66f7e&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb66f7e"]])

export default __exports__